// Therapies subsection form field enum
export enum TherapiesFormField {
  THERAPIES_THERAPIES = 'medicalBackground/therapies/therapies',
  THERAPIES_THERAPY_PROVIDER = 'medicalBackground/therapies/therapyProvider',
  THERAPIES_HOME_EXERCISE_PLAN = 'medicalBackground/therapies/homeExercisePlan',
  THERAPIES_HOME_EXERCISE_DURATION = 'medicalBackground/therapies/homeExerciseDuration',
  THERAPIES_HOME_EXERCISE_FREQUENCY = 'medicalBackground/therapies/homeExerciseFrequency'
}
